<template>
  <div class="cabinet-detail-container">
    <div class="jc-page-header">
      <h1>
        <a href="javascript:void(0)" @click="jump_to_up()">
          <i class="el-icon-arrow-left"></i>
        </a>{{$t('cabinet.cabinetDetail')}}
        <small>{{cabinetDetail['cabinetNo'] | maybeEmpty}}</small>
      </h1>
    </div>
    <div class="jc-page-content">

      <page-tabs
        :border-style="false"
        :tabs="getTabsData('dynamic')">
        <template slot="detail"></template>
        <template slot="dynamic">
          <el-row>
            <el-col :span="24">
              <div class="grid-content daterange">
                <!--时间范围-->
                <date-range v-model="dateRangeValue"
                  max-range-days="31"
                  :default-value="dateRangeDefault"
                  shortcut-days="24h,3d,7d,14d"
                  @change="onDateRangeChange" />
                <p>{{ $t('cabinet.maxDays', [31]) }}</p>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"><div class="grid-content">
              <div class="dyn-env-box" v-loading="chartLoading">
                <div class="header" v-if="dynamicEnvData">
                  <p>{{this.$t('cabinet.powerTrendChart')}}</p>
                  <p>{{this.$t('cabinet.period') | withColon}} 5min</p><!--这里暂时硬编码了时间-->
                </div>
                <div class="main">
                  <!--动环图表-->
                  <dynamic-env-chart
                    unit="A"
                    :is-empty="isChartEmpty"
                    :electric-currents="dynamicEnvData"
                    :y-axis-name="$t('cabinet.current')"
                    :series-names="$t('cabinet.currentNoUnit')"
                    :legend-names-map="{
                      [$t('cabinet.current')]: $t('cabinet.dynamicInformation')
                    }" />
                </div>
              </div>
            </div></el-col>
          </el-row>
        </template>
      </page-tabs>

    </div>
  </div>
</template>

<script>
import ChartHelper from './chart.helper';
import DetailMixin from './detail.mixin';
import PageTabs from '@/components/common/PageTabs';
import DateRange from '@/components/common/DateRange';
import DynamicEnvChart from '@/components/common/DynamicEnvChart';

export default {
  mixins: [
    DetailMixin
  ],
  components: {
    PageTabs,
    DateRange,
    DynamicEnvChart
  },
  data() {
    return {
      dateRangeDefault: '24h',
      cabinetDetail: null,
      dateRangeValue: null,
      dynamicEnvData: null,
      isChartEmpty: false,
      chartLoading: false
    };
  },
  async mounted() {
    const { idcId, cabinetId } = this.$route.query;
    const response = await this.$api.getCabinetInfo({ idcId, cabinetId });
    this.cabinetDetail = response.data.cabinetDetail;
  },
  methods: {
    onDateRangeChange() {
      if (!this.cabinetDetail) return;

      if (this.dateRangeValue === '') {
        this.dateRangeDefault = '';
        setTimeout(() => {
          this.dateRangeDefault = '24h';
        }, 0);
        return;
      }

      const { idcNo } = this.cabinetDetail;
      const { cabinetId } = this.$route.query;
      const [startTime, endTime] = this.dateRangeValue;

      const reqParam = {
        idcNo,
        cabinetId,
        startTime,
        endTime
      };

      this.chartLoading = true;
      this.$api.getCabinetCurrentInfo(reqParam).then((response) => {
        const { data } = response;
        if (!data || (Array.isArray(data) && !data.length)) {
          this.showEmptyChart();
          return;
        }
        this.dynamicEnvData = data;
        this.isChartEmpty = false;
      }).catch((error) => { // eslint-disable-line no-unused-vars
        this.showEmptyChart();
      }).finally(() => {
        this.chartLoading = false;
      });
    },
    showEmptyChart() {
      const [startTime, endTime] = this.dateRangeValue;
      this.dynamicEnvData = ChartHelper.getEmptyData(startTime, endTime);
      this.isChartEmpty = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./cabinetDetail.scss";
.dyn-env-box {
  height: 460px;
  margin: 15px 0;
  border: 1px solid #DCDCDC;

  .header {
    background: #F5F5F5;
    padding: 4px 9px;

    p {
      line-height: 22px;
      margin: 1px 0 0 1px;
      font-size: 12px;
      color: rgba($color: #000000, $alpha: .65);
    }
  }
}
.daterange {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  p {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cabinetDetail/DynamicDetail.vue